import http from '../../utils/fetch';
export default {
    //回复人列表
    selectUser(value){
        return http({
            url: '/api/swyl/v1/xuqiu/userResDemandJob/selectUser',
            method: 'post',
            params:value
        });
    },
    //需求详情-资源需求
    demandResourceDetail(v) {
        return http.post('/api/swyl/v1/guanhuai/userResourceDemand/selectById?id='+v);
    },
    //新增资源需求
    saveResource(query) {
        return http({
            url: '/api/swyl/v1/guanhuai/userResourceDemand/insert',
            method: 'post',
            data: query
        });
    },
    //经销商信息带出
    getAgentByCode(value){
        return http({
            url: '/api/swyl/v1/guanhuai/userResourceDemand/userResDemand/getAgentByCode',
            method: 'post',
            params:value
        });
    },
    //资源需求列表分页/检索
    showXTGLPage(query) {
        return http({
            url: '/api/swyl/v1/guanhuai/userResourceDemand/showXTGLPage',
            method: 'post',
            params: query
        });
    },
    //需求详情-资源需求
    resourceXTDetail(v) {
        return http.post('/api/swyl/v1/guanhuai/userResourceDemand/resourceXTDetail?id='+v);
    },

    //需求详情-资源需求闭环
    showXTzyBH(v) {
        return http.post('/api/swyl/v1/guanhuai/userResourceDemand/showXTzyBH?id='+v);
    },
    //需求详情-资源需求闭环
    showXTzyByInstid(v) {
        return http.post('/api/swyl/v1/guanhuai/userResourceDemand/showXTzyByInstid?instid='+v);
    },
    //需求详情-审批通过
    pass(query) {
        return http({
            url: '/api/swyl/v1/guanhuai/userResourceDemand/pass',
            method: 'post',
            data: query
        });
    },
    //回复
    xtHuifu(query) {
        return http({
            url: '/api/swyl/v1/guanhuai/userResourceDemand/xtHuifu',
            method: 'post',
            data: query
        });
    },
    //资源需求闭环
    updateXtYes(query) {
        return http({
            url: '/api/swyl/v1/guanhuai/userResourceDemand/updateXtYes',
            method: 'post',
            data: query
        });
    },
    //资源需求闭环校验
    checkBhStatus(v) {
        return http.post('/api/swyl/v1/guanhuai/userResourceDemand/checkBhStatus?id='+v);
    },
    // 承接部门下拉列表
    selectDeptPoint(value){
        return http.post('/api/swyl/v1/guanhuai/userResourceDemandJob/selectDeptGroup?jobGroup='+value);
    },
    //新增或修改承接部门/答复人信息
    insertDept(v){
        return http({
            url: '/api/swyl/v1/guanhuai/userResourceDemandJob/insertDept',
            method: 'post',
            params: v
        });
    },
    deleteDept(value){
        return http.post('/api/swyl/v1/guanhuai/userResourceDemandJob/deleteDept?id='+value);
    },
    selectDept(value){
        return http.post('/api/swyl/v1/guanhuai/userResourceDemandJob/selectDept?id='+value);
    },
    //分页查询承接部门/答复人信息
    deptUserPage(v){
        return http({
            url: '/api/swyl/v1/guanhuai/userResourceDemandJob/deptUserPage',
            method: 'post',
            params: v
        });
    },
    //回复人列表
    selectAnsUser(value){
        return http({
            url: '/api/swyl/v1/guanhuai/userResourceDemandJob/selectAnsUser',
            method: 'post',
            params:value
        });
    },
}
